export const profileConstants = {
       PROFILE_SUCCESS: 'PROFILE_SUCCESS',
}